module.exports = __webpack_public_path__ + "img/item1.c824184a.png";